export default __webpack_public_path__ + "assets/images/33df721f0aa5176c74b62cdf41be1503.jpg";